var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientContactCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1282,
    height: 894,
    viewBox: "0 0 1282 894",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0H641H1232C1259.61 0 1282 22.3858 1282 50V844C1282 871.614 1259.61 894 1232 894H50C22.3858 894 0 871.614 0 844V50Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.5 50V844C1281.5 871.338 1259.34 893.5 1232 893.5H50C22.6619 893.5 0.5 871.338 0.5 844V50C0.5 22.6619 22.6619 0.5 50 0.5H641H1232C1259.34 0.5 1281.5 22.6619 1281.5 50Z",
    stroke: "url(#paint0_linear_450_775)",
    strokeOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323 236.769C379.092 225.107 508.493 214.343 577.36 264.577C646.226 314.811 801.241 363.551 870.141 381.641C897.145 390.672 908.478 407.368 914.083 428.565C925.586 433.097 936.444 437.361 946.497 441.294L915.5 434.566C915.071 432.529 914.602 430.528 914.083 428.565C771.243 372.285 528.851 274.466 491.762 250.224C451.687 224.031 362.556 230.34 323 236.769Z",
    fill: "url(#paint1_linear_450_775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43176 177.166V67.2781C174.571 31.7552 238.607 52.4769 248.983 67.2781C367.262 162.364 387.105 242.949 382.242 271.355C375.919 293.033 340.416 319.347 248.983 251.172C157.549 182.996 45.8515 173.428 1.43176 177.166Z",
    fill: "url(#paint2_linear_450_775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886 339.502V229.614C1059.14 194.091 1123.18 214.813 1133.55 229.614C1251.83 324.7 1271.67 405.285 1266.81 433.691C1260.49 455.369 1224.98 481.683 1133.55 413.507C1042.12 345.332 930.42 335.764 886 339.502Z",
    fill: "url(#paint3_linear_450_775)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.47 477.502V367.614C302.33 332.091 238.294 352.813 227.919 367.614C109.639 462.7 89.7964 543.285 94.6598 571.691C100.982 593.369 136.486 619.683 227.919 551.507C319.352 483.332 431.05 473.764 475.47 477.502Z",
    fill: "url(#paint4_linear_450_775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.47 646.502V536.614C1095.33 501.091 1031.29 521.813 1020.92 536.614C902.639 631.7 882.796 712.285 887.66 740.691C893.982 762.369 929.486 788.683 1020.92 720.507C1112.35 652.332 1224.05 642.764 1268.47 646.502Z",
    fill: "url(#paint5_linear_450_775)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 661.502V551.614C698.14 516.091 762.175 536.813 772.551 551.614C890.83 646.7 910.673 727.285 905.81 755.691C899.487 777.369 863.984 803.683 772.551 735.507C681.117 667.332 569.42 657.764 525 661.502Z",
    fill: "url(#paint6_linear_450_775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 743.502V633.614C228.14 598.091 292.175 618.813 302.551 633.614C420.83 728.7 440.673 809.285 435.81 837.691C429.487 859.369 393.984 885.683 302.551 817.507C211.117 749.332 99.4197 739.764 55 743.502Z",
    fill: "url(#paint7_linear_450_775)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_450_775",
    x1: 241,
    y1: 508.95,
    x2: 703.244,
    y2: 200.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_450_775",
    x1: 643.989,
    y1: 227,
    x2: 643.989,
    y2: 441.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_450_775",
    x1: 335.066,
    y1: 224.709,
    x2: 12.7356,
    y2: 148.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_450_775",
    x1: 1219.63,
    y1: 387.045,
    x2: 897.304,
    y2: 311.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_450_775",
    x1: 141.836,
    y1: 525.045,
    x2: 464.166,
    y2: 449.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_450_775",
    x1: 934.836,
    y1: 694.045,
    x2: 1257.17,
    y2: 618.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_450_775",
    x1: 858.634,
    y1: 709.045,
    x2: 536.304,
    y2: 633.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_450_775",
    x1: 388.634,
    y1: 791.045,
    x2: 66.3038,
    y2: 715.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientContactCard);
export default __webpack_public_path__ + "static/media/gradient-contact-card.26aa3c943dd4d6daf1b6eb9682084fa5.svg";
export { ForwardRef as ReactComponent };